//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'geneva1',
  data() {
    return {
      defaultJson: {
        "Pain on lower limb deep venous palpation and unilateral edema": "单侧下肢深静脉触疼及单侧下肢水肿",
        "Heart Rate": "心率",
        "Hemoptysis": "咯血",
        "Previous DVT or PE": "既往 DVT 或 PE",
        "Probability: high": "可能性：高",
        "Probability: intermediate": "可能性：中",
        "Unilateral lower limb pain": "单侧下肢痛",
        "75 - 94": "75 - 94",
        "Surgery within 1 month": "1 月内手术史",
        "Age > 65 years": "年龄 > 65 岁",
        "Probability: low": "可能性：低",
        "≤ 74": "≤ 74",
        "≥ 95": "≥ 95",
        "Active malignancy": "活动期恶性肿瘤"
      },
      form: {
        age: '0',
        dvt: '0',
        surgery: '0',
        malignancy: '0',
        llpain: '0',
        hemoptysis: '0',
        edema: '0',
        hr: '',

      },
      dataList1: [
        { value: "0", name: '≤ 74' },
        { value: "3", name: '75 - 94' },
        { value: "5", name: '中≥ 95' },
      ],
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // 	age + (dvt * 3) + (surgery * 2) + (malignancy * 2) + (llpain * 3) + (hemoptysis * 2) + (edema * 4) + hr
        let result = form.age + (form.dvt * 3) + (form.surgery * 2) + (form.malignancy * 2) + (form.llpain * 3) + (form.hemoptysis * 2) + (form.edema * 4) + form.hr

        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/geneva1.vue